import { APIAdapter } from '@/lib/http';

const HS_API = 'https://www.hipaaspace.com/api';
const hsApi = APIAdapter(HS_API);

export default {
  searchPayers: (searchTerm) =>
    hsApi
      .get('/ein/search', {
        params: {
          q: searchTerm,
          rt: 'json',
          token: process.env.HIPAASPACE_TOKEN,
        },
      })
      .then((res) => res.data),
};
